import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, Modal, Nav, Row, Tab } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import { useAppContext } from 'providers/AppProvider';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import moment from 'moment';
import { postJobTable } from 'nursd-dashboard/api/jobTable';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';
// import FalconReactRange from 'components/doc-components/FalconReactRange';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';
import {
  duration,
  jobTypes,
  licenseTypes,
  templateTypes,
  timeOffTypes
} from 'nursd-dashboard/data/defaultData';
import {
  getTemplateType,
  postJobTemplate
} from 'nursd-dashboard/api/jobTemplate';
import SimpleBarReact from 'simplebar-react';
import { postNurseTimeOff } from 'nursd-dashboard/api/timeoffNurse';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { DateFormat, timeDifferentFun } from 'nursd-dashboard/utils/function';
import { socket } from 'nursd-dashboard/api/socket';
import TimeDropdown from './create_schedule/TimeDropdown';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

const AddScheduleModal = ({
  setIsOpenScheduleModal,
  isOpenScheduleModal,
  setInitialEvents,
  initialEvents,
  scheduleStartDate,
  setScheduleStartDate,
  scheduleEndDate,
  setScheduleEndDate,
  managers,
  customers,
  nurseList,
  authToken,
  location,
  organization
}) => {
  // const {
  //   config: { isDark }
  // } = useAppContext();

  const searchInput = useRef(null);

  const type = 'Shift';

  const animatedComponents = makeAnimated();

  const [valueDuration, setValueDuration] = useState(null);
  const [valueLicense, setValueLicense] = useState(null);
  const [valueManager, setValueManager] = useState(null);
  const [valueNurse, setValueNurse] = useState(null);
  const [valueCustomer, setValueCustomer] = useState(null);
  const [tab, setTab] = useState('Schedule');
  const [jobTemplateArray, setJobTemplateArray] = useState([]);
  const [selectedJobTemplate, setSelectedJobTemplate] = useState(null);
  const [valueJobTypes, setValueJobTypes] = useState({
    value: '1',
    label: 'Shift'
  });
  const [global, setGlobal] = useState({
    value: '1',
    label: 'Global'
  });
  const [timeOffType, setTimeOffType] = useState({
    value: '1',
    label: 'Full Day'
  });
  // const [type, settType] = useState('Shift');
  // const [duration, setDuration] = useState([1]);

  const [formData, setFormData] = useState({
    shiftTitle: '',
    startDate: new Date(),
    endDate: new Date(),
    break: 'No Break',
    customerName: null,
    customerId: '',
    unit: '',
    floor: '',
    fullAddress: '',
    latitude: '',
    longitude: '',
    notes: '',
    jobType: type,
    jobTiming: '',
    customerVisibility: false,
    autoAccept: false,
    baseRate: '',
    baseRateEnable: false,
    jobPostingTableFacilityTableId: '',
    jobPostingTableFacilityTableName: '',
    jobTemplateName: ''
  });

  useEffect(() => {
    if (selectedJobTemplate) {
      setValueCustomer(
        customers?.filter(
          type => selectedJobTemplate?.origin?.customerName === type?.label
        )
      );
      setValueLicense(
        licenseTypes.filter(type =>
          selectedJobTemplate?.origin?.licenseType?.includes(type.label)
        )
      );
      const startTime = moment(selectedJobTemplate?.origin?.startTime);

      // Get the AM/PM format
      const startTimeAMPM = startTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let shour = parseInt(startTime.format('hh'));

      // Adjust hour based on AM/PM
      if (startTimeAMPM === 'PM' && shour < 12) {
        shour += 12; // Convert PM hours to 24-hour format
      } else if (startTimeAMPM === 'AM' && shour === 12) {
        shour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const startDate = new Date(
        moment(formData?.startDate).format('YYYY'),
        moment(formData?.startDate).format('MM') - 1,
        moment(formData?.startDate).format('DD'),
        shour,
        moment(selectedJobTemplate?.origin?.startTime).format('mm'),
        moment(selectedJobTemplate?.origin?.startTime).format('ss'),
        0
      );

      const endTime = moment(selectedJobTemplate?.origin?.endTime);

      // Get the AM/PM format
      const endTimeAMPM = endTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let hour = parseInt(endTime.format('hh'));

      // Adjust hour based on AM/PM
      if (endTimeAMPM === 'PM' && hour < 12) {
        hour += 12; // Convert PM hours to 24-hour format
      } else if (endTimeAMPM === 'AM' && hour === 12) {
        hour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const endDate = new Date(
        moment(formData?.endDate).format('YYYY'),
        moment(formData?.endDate).format('MM') - 1,
        moment(formData?.endDate).format('DD'),
        hour, // Use the adjusted hour
        moment(selectedJobTemplate?.origin?.endTime).format('mm'),
        moment(selectedJobTemplate?.origin?.endTime).format('ss'),
        0
      );

      const filterDuration = duration?.filter(
        type => type?.value === timeDifferentFun(startDate, endDate)
      );
      setValueDuration(filterDuration);

      // console.log(moment(startDate).toString());
      let e = moment(startDate).add('hours', filterDuration[0]?.value);
      // console.log(moment(e).toString());

      setFormData({
        ...formData,
        shiftTitle: selectedJobTemplate?.origin?.shiftTitle,
        break: selectedJobTemplate?.origin?.break,
        customerName: selectedJobTemplate?.origin?.customerName,
        customerId: selectedJobTemplate?.origin?.customerId,
        unit: selectedJobTemplate?.origin?.unit,
        floor: selectedJobTemplate?.origin?.floor,
        fullAddress: selectedJobTemplate?.origin?.fullAddress,
        latitude: selectedJobTemplate?.origin?.latitude,
        longitude: selectedJobTemplate?.origin?.longitude,
        baseRate: selectedJobTemplate?.origin?.baseRate,
        enableBid: selectedJobTemplate?.origin?.enableBid,
        autoAccept: selectedJobTemplate?.origin?.autoAcceptedEnable,
        notes: selectedJobTemplate?.origin?.notes,
        maxBaseRate: selectedJobTemplate?.origin?.maxBidAmount,
        jobTiming: selectedJobTemplate?.origin?.jobTiming,
        specialtyRequired: selectedJobTemplate?.origin?.specialtyRequired,
        certificationRequired:
          selectedJobTemplate?.origin?.certificationRequired,
        experienceRequired: selectedJobTemplate?.origin?.experienceRequired,
        emrehrRequired: selectedJobTemplate?.origin?.emrehrRequired,
        customerVisibility: selectedJobTemplate?.origin?.customerVisibility,
        baseRateVisibility: selectedJobTemplate?.origin?.baseRateVisibility,
        startDate: startDate,
        endDate: new Date(e)
      });
    }
  }, [selectedJobTemplate]);

  // const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState('');

  const handleTimeChange = time => {
    setSelectedTime(time);
    let findAMorPM = time;
    const time24_1 = moment(findAMorPM, 'hh:mm A').format('HH:mm');
    formData?.startDate?.setHours(time24_1.toString()?.substring(0, 2));
    formData?.startDate?.setMinutes(time24_1.toString()?.substring(3, 5));
  };

  useEffect(() => {
    if (selectedTime !== '') {
      let date = formData?.startDate;
      let time = selectedTime;
      let findAMorPM = time;
      const time24_1 = moment(findAMorPM, 'hh:mm A').format('HH:mm');
      date?.setHours(time24_1.toString()?.substring(0, 2));
      date?.setMinutes(time24_1.toString()?.substring(3, 5));
      // console.log(date);
      // setFormData({
      //   ...formData,
      //   startDate: date
      // });
    }
  }, [selectedTime]);

  // console.log(selectedTime, formData.startDate, formData.endDate);

  const [timeFormData, setTimeFormData] = useState({
    startDate: new Date(),
    endDate: new Date(),
    timeOffReason: '',
    comments: '',
    phoneNumber: '',
    alternativePhoneNumber: '',
    jobPostingTableFacilityTableId: '',
    jobPostingTableFacilityTableName: ''
  });

  const getTemplateBasedOnManager = async (id, type) => {
    await getTemplateType(authToken, id, type)
      .then(res => {
        if (res) {
          let array = [];
          // console.log("Template", res)
          for (let index = 0; index < res.length; index++) {
            const element = res[index];
            let obj = {
              value: index + 1,
              label: element?.jobTemplateName,
              origin: element
            };
            array.push(obj);
          }
          setJobTemplateArray(array);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  function timeDifferent(sTime, eTime) {
    const startTime = moment(
      moment(new Date(sTime)).format('hh:mma'),
      'hh:mm A'
    );

    const start = moment(new Date(sTime));
    const end = moment(new Date(eTime));

    const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
    const endTimeEnd = moment(
      moment(new Date(eTime)).format('hh:mma'),
      'hh:mm A'
    ).add(1, 'day');

    const duration = moment.duration(endTime.diff(startTime));
    const durationEnd = moment.duration(endTimeEnd.diff(startTime));

    const hours = Math.floor(duration.asHours());
    const hoursEnd = Math.floor(durationEnd.asHours());
    const minutes = Math.floor(duration.asMinutes()) - hours * 60;

    // const onlyHours = `${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours
    //     : end.hour() <= 12
    //     ? hoursEnd
    //     : hours
    // } ${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours <= 1
    //       ? "hour"
    //       : "hours"
    //     : end.hour() <= 12
    //     ? hoursEnd <= 1
    //       ? "hour"
    //       : "hours"
    //     : hours <= 1
    //     ? "hour"
    //     : "hours"
    // }`;

    const onlyHours = `${
      end.hour() <= 12 && start.hour() <= 12
        ? hours
        : end.hour() <= 12
        ? hoursEnd
        : hours
    }${hours <= 1 ? 'hour' : 'hours'} ${
      minutes <= 0 ? '' : `${minutes}minutes`
    }`;

    return onlyHours;
  }

  const handleClose = () => {
    setIsOpenScheduleModal(!isOpenScheduleModal);
    setScheduleStartDate(null);
    setScheduleEndDate(null);
    setValueLicense(null);
    setValueManager(null);
    setValueCustomer(null);
    setValueDuration(null);
    setSelectedJobTemplate(null);
    setValueJobTypes({
      value: '1',
      label: 'Shift'
    });
    setGlobal({
      value: '1',
      label: 'Global'
    });
    setFormData({
      shiftTitle: '',
      startDate: new Date(),
      endDate: new Date(),
      break: 'No Break',
      customerName: null,
      customerId: '',
      unit: '',
      floor: '',
      fullAddress: '',
      latitude: '',
      longitude: '',
      notes: '',
      jobType: type,
      jobTiming: '',
      autoAccept: false,
      customerVisibility: false,
      baseRate: '',
      baseRateEnable: false,
      jobPostingTableFacilityTableId: '',
      jobPostingTableFacilityTableName: '',
      jobTemplateName: ''
    });
  };

  const handleCloseTimeOff = () => {
    setIsOpenScheduleModal(!isOpenScheduleModal);
    setScheduleStartDate(null);
    setScheduleEndDate(null);
    setValueManager(null);
    setValueNurse(null);
    setValueDuration(null);
    setTimeOffType({
      value: '1',
      label: 'Full Day'
    });
    setTimeFormData({
      startDate: new Date(),
      endDate: new Date(),
      timeOffReason: '',
      comments: '',
      phoneNumber: '',
      alternativePhoneNumber: '',
      jobPostingTableFacilityTableId: '',
      jobPostingTableFacilityTableName: ''
    });
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value =
      name === 'customerVisibility'
        ? target.checked
        : name === 'baseRateEnable'
        ? target.checked
        : name === 'autoAccept'
        ? target.checked
        : target.value;
    setFormData({ ...formData, [name]: value });
  };

  const handleChangeTimeOff = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setTimeFormData({ ...timeFormData, [name]: value });
  };

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleChange({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleChange({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleChange({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  const postJob = async () => {
    const ct = new Date(
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString()
    );
    const currentHour = ct.getHours();
    let jobTiming =
      currentHour >= 5 && currentHour < 12
        ? 'Morning'
        : currentHour >= 12 && currentHour < 17
        ? 'Afternoon'
        : currentHour >= 17 && currentHour < 20
        ? 'Evening'
        : 'Night';

    await postJobTable(
      authToken,
      valueLicense?.map(i => i?.label),
      formData?.shiftTitle,
      '',
      [],
      '',
      '0',
      moment(formData?.startDate).format('YYYY-MM-DD'),
      moment(formData?.endDate).format('YYYY-MM-DD'),
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString(),
      GetDateMergedTime(
        formData?.endDate,
        formData?.endDate?.toString()
      ).toString(),
      formData?.break,
      formData?.customerName,
      formData?.customerId?.toString(),
      formData?.unit,
      formData?.floor,
      formData?.fullAddress,
      formData?.latitude?.toString(),
      formData?.longitude?.toString(),
      '1',
      false,
      formData?.notes,
      valueJobTypes?.label,
      'Open',
      '',
      '',
      [],
      [],
      formData?.autoAccept,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      timeDifferent(formData?.startDate, formData?.endDate),
      jobTiming,
      '',
      [],
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      false,
      false,
      false,
      false,
      false,
      formData.customerVisibility,
      '',
      '',
      {},
      '',
      formData.jobPostingTableFacilityTableId?.toString(),
      false,
      '',
      '',
      '',
      false,
      false,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      GetDateMergedTime(formData?.startDate, formData.startDate?.toString())
        .valueOf()
        .toString(),
      '',
      '',
      '',
      '',
      organization,
      location
    )
      .then(item => {
        let obj = {
          id: item?.id,
          title: item?.shiftTitle,
          className: 'bg-warning-subtle',
          start: new Date(item?.startTime),
          end: new Date(item?.endTime),
          allDay: null,
          description: item?.fullAddress,
          original: item,
          editable: item?.jobStatus === 'Open'
        };
        nurseList?.map(async item => {
          if (item?.mobileId) {
            sendNotification(authToken, {
              expoPushToken: item?.mobileId,
              title: 'New Job',
              body: `${type} available in your area.`,
              data: { screen: 'HomeScreen' }
            });
          }
        });
        setInitialEvents([...initialEvents, obj]);
        setValueLicense(null);
        setValueManager(null);
        setValueCustomer(null);
        // setDuration([1]);
        setValueJobTypes({
          value: '1',
          label: 'Shift'
        });
        setFormData({
          shiftTitle: '',
          startDate: new Date(),
          endDate: new Date(),
          break: 'No Break',
          customerName: null,
          customerId: '',
          unit: '',
          floor: '',
          fullAddress: '',
          latitude: '',
          longitude: '',
          notes: '',
          jobType: type,
          jobTiming: '',
          customerVisibility: false,
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: '',
          jobTemplateName: ''
        });
        toast.success(item?.shiftTitle + ' created successfully.', {
          theme: 'colored'
        });
        setIsOpenScheduleModal(false);
      })
      .catch(error => {
        console.log('data save error:', error);
      });
  };

  const postTemplate = async () => {
    const ct = new Date(
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString()
    );
    const currentHour = ct.getHours();
    let jobTiming =
      currentHour >= 5 && currentHour < 12
        ? 'Morning'
        : currentHour >= 12 && currentHour < 17
        ? 'Afternoon'
        : currentHour >= 17 && currentHour < 20
        ? 'Evening'
        : 'Night';
    try {
      await postJobTemplate(
        authToken,
        valueLicense?.map(i => i?.label),
        formData.shiftTitle,
        '',
        [],
        '',
        '0',
        moment(formData?.startDate).format('YYYY-MM-DD'),
        moment(formData?.endDate).format('YYYY-MM-DD'),
        GetDateMergedTime(
          formData?.startDate,
          formData?.startDate?.toString()
        ).toString(),
        GetDateMergedTime(
          formData?.endDate,
          formData?.endDate?.toString()
        ).toString(),
        formData?.break,
        formData?.customerName,
        formData?.customerId?.toString(),
        formData?.unit,
        formData?.floor,
        formData?.fullAddress,
        formData?.latitude?.toString(),
        formData?.longitude?.toString(),
        formData?.baseRate !== '' ? formData?.baseRate : '1',
        formData?.enableBid,
        formData?.notes,
        valueJobTypes?.label,
        formData.autoAccept,
        '',
        '',
        timeDifferent(formData?.startDate, formData?.endDate),
        jobTiming,
        '',
        [],
        false,
        false,
        false,
        false,
        formData.customerVisibility,
        formData.jobPostingTableFacilityTableId?.toString(),
        false,
        GetDateMergedTime(formData?.startDate, formData.startDate?.toString())
          .valueOf()
          .toString(),
        organization,
        location,
        formData.jobTemplateName,
        [
          {
            templateType: global.label
          }
        ],
        []
      ).then(() => {
        // console.log(res)
        // setLoading(false);
        toast.success(formData.jobTemplateName + ' created successfully.', {
          theme: 'colored'
        });
        setValueLicense([]);
        setValueManager([]);
        setValueCustomer([]);
        setValueDuration([]);
        setGlobal({
          value: '1',
          label: 'Global'
        });
        setValueJobTypes({
          value: '1',
          label: 'Shift'
        });
        setFormData({
          shiftTitle: '',
          startDate: new Date(),
          endDate: new Date(),
          break: 'No Break',
          customerName: null,
          customerId: '',
          unit: '',
          floor: '',
          fullAddress: '',
          latitude: '',
          longitude: '',
          notes: '',
          jobType: type,
          jobTiming: '',
          customerVisibility: false,
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: '',
          jobTemplateName: ''
        });
        setIsOpenScheduleModal(false);
      });
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const postTimeOff = async () => {
    console.log(
      authToken,
      valueNurse?.value,
      timeFormData.timeOffReason,
      moment(timeFormData?.startDate).format('YYYY-MM-DD'),
      timeOffType?.label === 'Full Day'
        ? ''
        : GetDateMergedTime(
            timeFormData?.startDate,
            timeFormData?.startDate?.toString()
          ).toString(),
      moment(timeFormData.endDate).format('YYYY-MM-DD'),
      timeOffType?.label === 'Full Day'
        ? ''
        : GetDateMergedTime(
            timeFormData?.endDate,
            timeFormData?.endDate?.toString()
          ).toString(),
      timeFormData.alternativePhoneNumber,
      timeFormData.phoneNumber,
      organization,
      location,
      timeFormData.comments,
      'Approved',
      '',
      timeFormData?.jobPostingTableFacilityTableId
    );
    await postNurseTimeOff(
      authToken,
      valueNurse?.value?.toString(),
      timeFormData.timeOffReason,
      moment(timeFormData?.startDate).format('YYYY-MM-DD'),
      timeOffType?.label === 'Full Day'
        ? ''
        : GetDateMergedTime(
            timeFormData?.startDate,
            timeFormData?.startDate?.toString()
          ).toString(),
      moment(timeFormData.endDate).format('YYYY-MM-DD'),
      timeOffType?.label === 'Full Day'
        ? ''
        : GetDateMergedTime(
            timeFormData?.endDate,
            timeFormData?.endDate?.toString()
          ).toString(),
      timeFormData.alternativePhoneNumber,
      timeFormData.phoneNumber,
      organization,
      location,
      timeFormData.comments,
      'Approved',
      '',
      timeFormData?.jobPostingTableFacilityTableId?.toString()
    )
      .then(async () => {
        await postNurseNotification(
          authToken,
          valueNurse?.value,
          '',
          `Time Off Request(${DateFormat(timeFormData?.startDate)})`,
          `Time off Request Approved.`,
          'TimeOffScreen',
          {
            id: ''
          },
          false,
          false,
          'green',
          ''
        );
        sendNotification(authToken, {
          expoPushToken: valueNurse?.original?.mobileId,
          title: `Time Off Request(${DateFormat(timeFormData?.startDate)})`,
          body: `Time off Request Approved.`,
          data: { screen: 'TimeOffScreen' }
        });
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: valueNurse?.value
        });
        setIsOpenScheduleModal(!isOpenScheduleModal);
        setScheduleStartDate(null);
        setScheduleEndDate(null);
        setValueManager(null);
        setValueNurse(null);
        setValueDuration(null);
        setTimeOffType({
          value: '1',
          label: 'Full Day'
        });
        setTimeFormData({
          startDate: new Date(),
          endDate: new Date(),
          timeOffReason: '',
          comments: '',
          phoneNumber: '',
          alternativePhoneNumber: '',
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: ''
        });
      })
      .catch(e => console.log(e));
  };

  const handleSubmit = e => {
    e.preventDefault();
    postJob();
  };

  const handleSubmitTemplate = e => {
    e.preventDefault();
    postTemplate();
  };

  const handleSubmitTimeOff = e => {
    e.preventDefault();
    postTimeOff();
  };

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  useEffect(() => {
    if (formData.jobPostingTableFacilityTableId !== '') {
      getTemplateBasedOnManager(
        formData.jobPostingTableFacilityTableId?.toString(),
        valueJobTypes?.label
      );
    }
  }, [formData, valueJobTypes]);

  useEffect(() => {
    if (valueJobTypes?.label !== 'Visit') {
      if (selectedJobTemplate === null && valueDuration === null) {
        if (scheduleStartDate) {
          setFormData({
            ...formData,
            startDate: scheduleStartDate,
            endDate: scheduleEndDate
          });
        } else {
          setFormData({
            ...formData,
            startDate: new Date(),
            endDate: new Date()
          });
          setScheduleStartDate(new Date());
          setScheduleEndDate(new Date());
        }
      }
    }
  }, [
    isOpenScheduleModal,
    scheduleStartDate,
    scheduleEndDate,
    selectedJobTemplate,
    valueDuration
  ]);

  const TabTitle = ({ title }) => (
    <div
      className="p-2 pe-4 text-start cursor-pointer"
      onClick={() => setTab(title)}
    >
      <h6 className="text-800 fs-8 text-nowrap">{title}</h6>
    </div>
  );

  TabTitle.propTypes = {
    title: PropTypes.string.isRequired
  };

  return (
    <Modal
      size="xl"
      show={isOpenScheduleModal}
      backdrop="static"
      keyboard={false}
      aria-labelledby="example-modal-sizes-title-lg"
      onHide={handleClose}
      contentClassName="border"
    >
      <Tab.Container id="audience-tab" defaultActiveKey="Schedule">
        <SimpleBarReact>
          <Card.Header className="p-0 bg-body-tertiary">
            <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="Schedule">
                  <TabTitle title="Schedule" />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="Template">
                  <TabTitle title="Template" />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="TimeOff">
                  <TabTitle title="TimeOff" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
        </SimpleBarReact>
      </Tab.Container>

      {tab === 'Schedule' ? (
        <Form onSubmit={handleSubmit}>
          <Modal.Body className="p-x1">
            <Row className="mb-2">
              <Form.Group as={Col} md="4" className="mb-2" controlId="JobType">
                <Form.Label className="fs-9">Job Type</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueJobTypes}
                  onChange={value => {
                    setValueJobTypes(
                      value
                        ? value
                        : {
                            value: '1',
                            label: 'Shift'
                          }
                    );
                  }}
                  options={jobTypes}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="Manager">
                <Form.Label className="fs-9">Manager</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueManager}
                  onChange={value => {
                    setValueManager(value);
                    setFormData({
                      ...formData,
                      jobPostingTableFacilityTableName: value?.label,
                      jobPostingTableFacilityTableId: value?.id
                    });
                  }}
                  options={managers}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              {formData.jobPostingTableFacilityTableId && (
                <Form.Group
                  as={Col}
                  md="4"
                  className="mb-2"
                  controlId="License"
                >
                  <Form.Label className="fs-9">Template</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={jobTemplateArray}
                    placeholder="Select..."
                    classNamePrefix="react-select"
                    value={selectedJobTemplate}
                    onChange={value => {
                      setSelectedJobTemplate(value);
                    }}
                    components={animatedComponents}
                  />
                </Form.Group>
              )}
              <Form.Group as={Col} md="4" className="mb-2" controlId="License">
                <Form.Label className="fs-9">License</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={licenseTypes}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueLicense}
                  onChange={value => {
                    setValueLicense(value);
                  }}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md={8}
                className="mb-2"
                controlId="shiftTitle"
              >
                <Form.Label className="fs-9">Title</Form.Label>
                <Form.Control
                  type="text"
                  name="shiftTitle"
                  placeholder="Title"
                  required
                  value={formData?.shiftTitle}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md={valueJobTypes?.label === 'Shift' ? '3' : '6'}
                className="mb-2"
                controlId="startDate"
              >
                <Form.Label className="fs-9">Start</Form.Label>
                <div
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'row',
                    borderRadius: 5,
                    boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
                    padding: '5px 2px',
                    overflowY: 'auto'
                  }}
                >
                  <DatePicker
                    selected={formData?.startDate}
                    minDate={moment().toDate()}
                    minTime={
                      moment(formData?.startDate).format('MM/DD/YYYYY') ===
                      moment().format('MM/DD/YYYYY')
                        ? moment().toDate() // Set minTime to current time if today
                        : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                    }
                    maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                    onChange={v => {
                      setScheduleStartDate(v);

                      if (valueJobTypes?.label === 'Visit') {
                        let date = moment(new Date(v)).add('hour', 1);
                        // console.log({
                        //   startDate: v,
                        //   endDate: new Date(date)
                        // });
                        setFormData({
                          ...formData,
                          startDate: v,
                          endDate: new Date(date)
                        });
                      } else {
                        // console.log({
                        //   startDate: v
                        // });
                        let fst = moment(formData.startDate).format('hh:mm a');
                        let nsd = moment(v).format('YYYY-MM-DD');
                        let sd = moment(`${nsd} ${fst}`).toString();
                        console.log(valueDuration);
                        if (valueDuration === null) {
                          setFormData({
                            ...formData,
                            startDate: new Date(sd),
                            endDate: new Date(sd)
                          });
                          console.log('if', new Date(sd));
                        } else {
                          let e = moment(sd)
                            .add('hours', valueDuration[0]?.value)
                            .toString();
                          console.log('else', new Date(sd));
                          console.log('else', new Date(e));
                          setFormData({
                            ...formData,
                            startDate: new Date(sd),
                            endDate: new Date(e)
                          });
                        }
                      }
                    }}
                    className="form-control"
                    placeholderText="MM-DD-YYYY"
                    dateFormat="MM-dd-yyyy"
                  />
                  <TimeDropdown
                    time={formData.startDate}
                    selectedDate={formData.startDate}
                    selectedTime={selectedTime}
                    handleTimeChange={handleTimeChange}
                  />
                </div>
              </Form.Group>
              {valueJobTypes?.label === 'Shift' && (
                <Form.Group
                  as={Col}
                  md="3"
                  className="mb-2"
                  controlId="Duration"
                >
                  <Form.Label className="fs-9">Duration</Form.Label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Select..."
                    isClearable
                    isSearchable
                    name="color"
                    value={valueDuration}
                    onChange={value => {
                      setValueDuration(value);

                      let date = new Date();
                      let dateEnd = new Date();
                      let newEnd = new Date(formData.startDate);
                      let selectedHourTime =
                        newEnd.getHours() === 0
                          ? 12
                          : newEnd.getHours() > 12
                          ? newEnd.getHours() - 12
                          : newEnd.getHours();
                      let selectedMinuteTime = newEnd
                        .getMinutes()
                        .toString()
                        .padStart(2, '0');
                      let selectedAPTime =
                        newEnd.getHours() >= 12 ? 'PM' : 'AM';

                      date.setHours(
                        selectedAPTime === 'AM' && selectedHourTime === 12
                          ? 0
                          : selectedAPTime === 'PM' && selectedHourTime === 12
                          ? 12
                          : selectedHourTime !== 12 && selectedAPTime === 'PM'
                          ? parseInt(selectedHourTime) + 12
                          : parseInt(selectedHourTime)
                      );
                      date.setMinutes(selectedMinuteTime);
                      date.setFullYear(newEnd.getFullYear());
                      date.setMonth(newEnd.getMonth());
                      date.setDate(newEnd.getDate());

                      // Add 8 hours to dateEnd based on date
                      dateEnd.setFullYear(date.getFullYear());
                      dateEnd.setMonth(date.getMonth());
                      dateEnd.setDate(date.getDate());
                      dateEnd.setHours(date.getHours() + value?.value);
                      dateEnd.setMinutes(date.getMinutes());

                      // Determine if it's AM or PM
                      let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                      if (selectedAPTime === 'PM' && meridiem === 'AM') {
                        // let endDate = moment(formData.startDate);
                        // endDate.add(1, 'day');
                        setFormData({
                          ...formData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      } else {
                        setFormData({
                          ...formData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      }
                    }}
                    options={duration}
                    components={animatedComponents}
                  />
                </Form.Group>
              )}
              <Form.Group
                as={Col}
                md={valueJobTypes?.label === 'Shift' ? '3' : '6'}
                className="mb-2"
                controlId="End"
              >
                <Form.Label className="fs-9">End</Form.Label>
                <Form.Control
                  type="text"
                  name="End"
                  disabled
                  value={moment(formData?.endDate).format('MM-DD-YYYY hh:mm A')}
                />
              </Form.Group>
              {valueJobTypes.label === 'Shift' && (
                <Form.Group as={Col} className="mb-2" controlId="Break">
                  <Form.Label className="fs-9">Break</Form.Label>
                  <Form.Select
                    name="className"
                    onChange={event => {
                      const value = event.target.value;
                      let date = new Date(formData.endDate);
                      let dateEnd = new Date(formData.endDate);
                      dateEnd.setFullYear(date.getFullYear());
                      dateEnd.setMonth(date.getMonth());
                      dateEnd.setDate(date.getDate());
                      dateEnd.setHours(
                        value === '1 Hour'
                          ? date.getHours() + 1
                          : date.getHours()
                      );
                      dateEnd.setMinutes(
                        value === '15 Minutes'
                          ? date.getMinutes() + 15
                          : value === '30 Minutes'
                          ? date.getMinutes() + 30
                          : value === '45 Minutes'
                          ? date.getMinutes() + 45
                          : date.getMinutes()
                      );
                      setFormData({
                        ...formData,
                        break: value,
                        endDate: dateEnd
                      });
                    }}
                    value={formData?.break}
                    required
                  >
                    <option value="No Break">No Break</option>
                    <option value="15 Minutes">15 Minutes</option>
                    <option value="30 Minutes">30 Minutes</option>
                    <option value="45 Minutes">45 Minutes</option>
                    <option value="1 Hour">1 Hour</option>
                  </Form.Select>
                </Form.Group>
              )}
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={6} className="mb-2" controlId="Customer">
                <Form.Label className="fs-9">Customer</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueCustomer}
                  onChange={value => {
                    setValueCustomer(value);
                    setFormData({
                      ...formData,
                      customerName: value?.label,
                      customerId: value?.value,
                      fullAddress: value?.address,
                      latitude: value?.latitude,
                      longitude: value?.longitude
                    });
                  }}
                  options={customers}
                  components={animatedComponents}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mb-2"
                controlId="FullAddress"
              >
                <Form.Label className="fs-9">Full Address</Form.Label>
                <Form.Control
                  required
                  ref={searchInput}
                  contentEditable={false}
                  type="text"
                  placeholder="Full Address"
                  value={formData?.fullAddress}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="3" className="mb-2" controlId="Unit">
                <Form.Label className="fs-9">Unit</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Unit"
                  value={formData?.unit}
                  name="unit"
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="3" className="mb-2" controlId="Floor">
                <Form.Label className="fs-9">Floor</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Floor"
                  name="floor"
                  value={formData?.floor}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mb-2 pt-4"
                controlId="customerVisibility"
              >
                <Form.Check
                  type="checkbox"
                  id="customerVisibility"
                  label="Customer Visible After Assignment"
                  name="customerVisibility"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            {/* <Form.Group className="mb-2">
            <Form.Label className="fs-9">Schedule Meeting</Form.Label>
            <div>
              <Button
                as={Link}
                variant="link"
                to="#!"
                // type="button"
                className="badge-subtle-success fw-medium"
                size="sm"
              >
                <FontAwesomeIcon icon="video" className="me-2" />
                <span>Add video conference link</span>
              </Button>
            </div>
          </Form.Group> */}
            <Form.Group className="mb-2" controlId="notes">
              <Form.Label className="fs-9">Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                onChange={handleChange}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
            <Button
              variant="link"
              as={Link}
              to={paths.nursd_schedule_form}
              className="px-4 mx-0 text-dark"
            >
              Advanced
            </Button>
            <Button variant="primary" type="submit" className="px-4 mx-0">
              Create Job
            </Button>
            <Button
              variant="secondary"
              type="submit"
              className="px-4 mx-2"
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      ) : tab === 'Template' ? (
        <Form onSubmit={handleSubmitTemplate}>
          <Modal.Body className="p-x1">
            <Row className="mb-2">
              <Form.Group as={Col} md="4" className="mb-2" controlId="JobType">
                <Form.Label className="fs-9">Job Type</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueJobTypes}
                  onChange={value => {
                    setValueJobTypes(
                      value
                        ? value
                        : {
                            value: '1',
                            label: 'Shift'
                          }
                    );
                  }}
                  options={jobTypes}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="Manager">
                <Form.Label className="fs-9">Manager</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueManager}
                  onChange={value => {
                    setValueManager(value);
                    setFormData({
                      ...formData,
                      jobPostingTableFacilityTableName: value?.label,
                      jobPostingTableFacilityTableId: value?.id
                    });
                  }}
                  options={managers}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="License">
                <Form.Label className="fs-9">License</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={licenseTypes}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueLicense}
                  onChange={value => {
                    setValueLicense(value);
                  }}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md={4}
                className="mb-2"
                controlId="shiftTitle"
              >
                <Form.Label className="fs-9">Title</Form.Label>
                <Form.Control
                  type="text"
                  name="shiftTitle"
                  placeholder="Title"
                  required
                  value={formData?.shiftTitle}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md={4}
                className="mb-2"
                controlId="jobTemplateName"
              >
                <Form.Label className="fs-9">Template Name</Form.Label>
                <Form.Control
                  type="text"
                  name="jobTemplateName"
                  placeholder="Template Name"
                  required
                  value={formData?.jobTemplateName}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="JobType">
                <Form.Label className="fs-9">Template Type</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={global}
                  onChange={value => {
                    setGlobal(
                      value
                        ? value
                        : {
                            value: '1',
                            label: 'Global'
                          }
                    );
                  }}
                  options={templateTypes}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md={valueJobTypes?.label === 'Shift' ? '3' : '6'}
                className="mb-2"
                controlId="startDate"
              >
                <Form.Label className="fs-9">Start</Form.Label>
                <DatePicker
                  selected={formData?.startDate}
                  minDate={moment().toDate()}
                  minTime={
                    moment(formData?.startDate).format('MM/DD/YYYYY') ===
                    moment().format('MM/DD/YYYYY')
                      ? moment().toDate() // Set minTime to current time if today
                      : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                  }
                  maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                  onChange={v => {
                    setScheduleStartDate(v);
                    if (valueJobTypes?.label === 'Visit') {
                      let date = moment(new Date(v)).add('hour', 1);
                      // console.log({
                      //   startDate: v,
                      //   endDate: new Date(date)
                      // });
                      setFormData({
                        ...formData,
                        startDate: v,
                        endDate: new Date(date)
                      });
                    } else {
                      // console.log({
                      //   startDate: v
                      // });
                      setFormData({ ...formData, startDate: v, endDate: v });
                    }
                  }}
                  className="form-control"
                  placeholderText="MM-DD-YYYY H:M"
                  dateFormat="MM-dd-yyyy h:mm aa"
                  showTimeSelect
                />
              </Form.Group>
              {valueJobTypes?.label === 'Shift' && (
                <Form.Group
                  as={Col}
                  md="3"
                  className="mb-2"
                  controlId="Duration"
                >
                  <Form.Label className="fs-9">Duration</Form.Label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Select..."
                    isClearable
                    isSearchable
                    name="color"
                    value={valueDuration}
                    onChange={value => {
                      setValueDuration(value);

                      let date = new Date();
                      let dateEnd = new Date();
                      let newEnd = new Date(formData.startDate);
                      let selectedHourTime =
                        newEnd.getHours() === 0
                          ? 12
                          : newEnd.getHours() > 12
                          ? newEnd.getHours() - 12
                          : newEnd.getHours();
                      let selectedMinuteTime = newEnd
                        .getMinutes()
                        .toString()
                        .padStart(2, '0');
                      let selectedAPTime =
                        newEnd.getHours() >= 12 ? 'PM' : 'AM';

                      date.setHours(
                        selectedAPTime === 'AM' && selectedHourTime === 12
                          ? 0
                          : selectedAPTime === 'PM' && selectedHourTime === 12
                          ? 12
                          : selectedHourTime !== 12 && selectedAPTime === 'PM'
                          ? parseInt(selectedHourTime) + 12
                          : parseInt(selectedHourTime)
                      );
                      date.setMinutes(selectedMinuteTime);
                      date.setFullYear(newEnd.getFullYear());
                      date.setMonth(newEnd.getMonth());
                      date.setDate(newEnd.getDate());

                      // Add 8 hours to dateEnd based on date
                      dateEnd.setFullYear(date.getFullYear());
                      dateEnd.setMonth(date.getMonth());
                      dateEnd.setDate(date.getDate());
                      dateEnd.setHours(date.getHours() + value?.value);
                      dateEnd.setMinutes(date.getMinutes());

                      // Determine if it's AM or PM
                      let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                      if (selectedAPTime === 'PM' && meridiem === 'AM') {
                        // let endDate = moment(formData.startDate);
                        // endDate.add(1, 'day');
                        setFormData({
                          ...formData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      } else {
                        setFormData({
                          ...formData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      }
                    }}
                    options={duration}
                    components={animatedComponents}
                  />
                </Form.Group>
              )}
              <Form.Group
                as={Col}
                md={valueJobTypes?.label === 'Shift' ? '3' : '6'}
                className="mb-2"
                controlId="End"
              >
                <Form.Label className="fs-9">End</Form.Label>
                <Form.Control
                  type="text"
                  name="End"
                  disabled
                  value={moment(formData?.endDate).format('MM-DD-YYYY hh:mm A')}
                />
              </Form.Group>

              {valueJobTypes.label === 'Shift' && (
                <Form.Group as={Col} className="mb-2" controlId="Break">
                  <Form.Label className="fs-9">Break</Form.Label>
                  <Form.Select
                    name="className"
                    onChange={event => {
                      const value = event.target.value;
                      let date = new Date(formData.endDate);
                      let dateEnd = new Date(formData.endDate);
                      dateEnd.setFullYear(date.getFullYear());
                      dateEnd.setMonth(date.getMonth());
                      dateEnd.setDate(date.getDate());
                      dateEnd.setHours(
                        value === '1 Hour'
                          ? date.getHours() + 1
                          : date.getHours()
                      );
                      dateEnd.setMinutes(
                        value === '15 Minutes'
                          ? date.getMinutes() + 15
                          : value === '30 Minutes'
                          ? date.getMinutes() + 30
                          : value === '45 Minutes'
                          ? date.getMinutes() + 45
                          : date.getMinutes()
                      );
                      setFormData({
                        ...formData,
                        break: value,
                        endDate: dateEnd
                      });
                    }}
                    value={formData?.break}
                    required
                  >
                    <option value="No Break">No Break</option>
                    <option value="15 Minutes">15 Minutes</option>
                    <option value="30 Minutes">30 Minutes</option>
                    <option value="45 Minutes">45 Minutes</option>
                    <option value="1 Hour">1 Hour</option>
                  </Form.Select>
                </Form.Group>
              )}
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={6} className="mb-2" controlId="Customer">
                <Form.Label className="fs-9">Customer</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueCustomer}
                  onChange={value => {
                    setValueCustomer(value);
                    setFormData({
                      ...formData,
                      customerName: value?.label,
                      customerId: value?.value,
                      fullAddress: value?.address,
                      latitude: value?.latitude,
                      longitude: value?.longitude
                    });
                  }}
                  options={customers}
                  components={animatedComponents}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mb-2"
                controlId="FullAddress"
              >
                <Form.Label className="fs-9">Full Address</Form.Label>
                <Form.Control
                  required
                  ref={searchInput}
                  contentEditable={false}
                  type="text"
                  placeholder="Full Address"
                  value={formData?.fullAddress}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md="3" className="mb-2" controlId="Unit">
                <Form.Label className="fs-9">Unit</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Unit"
                  value={formData?.unit}
                  name="unit"
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="3" className="mb-2" controlId="Floor">
                <Form.Label className="fs-9">Floor</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Floor"
                  name="floor"
                  value={formData?.floor}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mb-2 pt-4"
                controlId="customerVisibility"
              >
                <Form.Check
                  type="checkbox"
                  id="customerVisibility"
                  label="Customer Visible After Assignment"
                  name="customerVisibility"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            {/* <Form.Group className="mb-2">
            <Form.Label className="fs-9">Schedule Meeting</Form.Label>
            <div>
              <Button
                as={Link}
                variant="link"
                to="#!"
                // type="button"
                className="badge-subtle-success fw-medium"
                size="sm"
              >
                <FontAwesomeIcon icon="video" className="me-2" />
                <span>Add video conference link</span>
              </Button>
            </div>
          </Form.Group> */}
            <Form.Group className="mb-2" controlId="notes">
              <Form.Label className="fs-9">Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                onChange={handleChange}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
            <Button
              variant="link"
              as={Link}
              to={paths.nursd_template_form}
              className="px-4 mx-0 text-dark"
            >
              Advanced
            </Button>
            <Button variant="primary" type="submit" className="px-4 mx-0">
              Create Template
            </Button>
            <Button
              variant="secondary"
              type="submit"
              className="px-4 mx-2"
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      ) : (
        <Form onSubmit={handleSubmitTimeOff}>
          <Modal.Body className="p-x1">
            <Row className="mb-2">
              <Form.Group as={Col} md="6" className="mb-2" controlId="Manager">
                <Form.Label className="fs-9">Manager</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueManager}
                  onChange={value => {
                    setValueManager(value);
                    setTimeFormData({
                      ...timeFormData,
                      jobPostingTableFacilityTableName: value?.label,
                      jobPostingTableFacilityTableId: value?.id
                    });
                  }}
                  options={managers}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md={6} className="mb-2" controlId="Nurse">
                <Form.Label className="fs-9">Nurse</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueNurse}
                  onChange={value => {
                    setValueNurse(value);
                    setTimeFormData({
                      ...timeFormData,
                      phoneNumber: value?.original?.phoneNumber
                    });
                  }}
                  options={nurseList}
                  components={animatedComponents}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="mb-2" controlId="TimeType">
                <Form.Label className="fs-9">Time Off Type</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={timeOffType}
                  onChange={value => {
                    setTimeOffType(
                      value
                        ? value
                        : {
                            value: '1',
                            label: 'Full Day'
                          }
                    );
                  }}
                  options={timeOffTypes}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md={4}
                className="mb-2"
                controlId="startDate"
              >
                <Form.Label className="fs-9">Start</Form.Label>
                <DatePicker
                  selected={scheduleStartDate}
                  minDate={moment().toDate()}
                  minTime={
                    moment(scheduleStartDate).format('MM/DD/YYYYY') ===
                    moment().format('MM/DD/YYYYY')
                      ? moment().toDate() // Set minTime to current time if today
                      : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                  }
                  maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                  onChange={v => {
                    setScheduleStartDate(v);
                    let date = moment(new Date(v)).add('hour', 1);
                    // console.log({
                    //   startDate: v,
                    //   endDate: new Date(date)
                    // });
                    setTimeFormData({
                      ...timeFormData,
                      startDate: v,
                      endDate: new Date(date)
                    });
                  }}
                  className="form-control"
                  placeholderText={
                    timeOffType.label === 'Full Day'
                      ? 'MM-DD-YYYY'
                      : 'MM-DD-YYYY H:M'
                  }
                  dateFormat={
                    timeOffType.label === 'Full Day'
                      ? 'MM-dd-yyyy'
                      : 'MM-dd-yyyy h:mm aa'
                  }
                  showTimeSelect={
                    timeOffType.label === 'Full Day' ? false : true
                  }
                />
              </Form.Group>
              {timeOffType.label === 'Partial Day' && (
                <Form.Group
                  as={Col}
                  md={4}
                  className="mb-2"
                  controlId="Duration"
                >
                  <Form.Label className="fs-9">
                    Duration{' '}
                    <span className="text-success">
                      (End-
                      {moment(timeFormData?.endDate).format('hh:mm A')})
                    </span>
                  </Form.Label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Select..."
                    isClearable
                    isSearchable
                    name="color"
                    value={valueDuration}
                    onChange={value => {
                      setValueDuration(value);

                      let date = new Date();
                      let dateEnd = new Date();
                      let newEnd = new Date(formData.startDate);
                      let selectedHourTime =
                        newEnd.getHours() === 0
                          ? 12
                          : newEnd.getHours() > 12
                          ? newEnd.getHours() - 12
                          : newEnd.getHours();
                      let selectedMinuteTime = newEnd
                        .getMinutes()
                        .toString()
                        .padStart(2, '0');
                      let selectedAPTime =
                        newEnd.getHours() >= 12 ? 'PM' : 'AM';

                      date.setHours(
                        selectedAPTime === 'AM' && selectedHourTime === 12
                          ? 0
                          : selectedAPTime === 'PM' && selectedHourTime === 12
                          ? 12
                          : selectedHourTime !== 12 && selectedAPTime === 'PM'
                          ? parseInt(selectedHourTime) + 12
                          : parseInt(selectedHourTime)
                      );
                      date.setMinutes(selectedMinuteTime);
                      date.setFullYear(newEnd.getFullYear());
                      date.setMonth(newEnd.getMonth());
                      date.setDate(newEnd.getDate());

                      // Add 8 hours to dateEnd based on date
                      dateEnd.setFullYear(date.getFullYear());
                      dateEnd.setMonth(date.getMonth());
                      dateEnd.setDate(date.getDate());
                      dateEnd.setHours(date.getHours() + value?.value);
                      dateEnd.setMinutes(date.getMinutes());

                      // Determine if it's AM or PM
                      let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                      if (selectedAPTime === 'PM' && meridiem === 'AM') {
                        // let endDate = moment(formData.startDate);
                        // endDate.add(1, 'day');
                        setTimeFormData({
                          ...timeFormData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      } else {
                        setTimeFormData({
                          ...timeFormData,
                          startDate: date,
                          endDate: dateEnd
                        });
                      }
                    }}
                    options={duration}
                    components={animatedComponents}
                  />
                </Form.Group>
              )}
              {timeOffType.label === 'Full Day' && (
                <Form.Group as={Col} md={4} className="mb-2" controlId="End">
                  <Form.Label className="fs-9">End</Form.Label>
                  <Form.Control
                    type="text"
                    name="End"
                    disabled
                    value={moment(timeFormData?.endDate).format('MM-DD-YYYY')}
                  />
                </Form.Group>
              )}
            </Row>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md={12}
                className="mb-2"
                controlId="timeOffReason"
              >
                <Form.Label className="fs-9">Time Off Reason</Form.Label>
                <Form.Control
                  type="text"
                  name="timeOffReason"
                  placeholder="Time Off Reason"
                  required
                  value={timeFormData?.timeOffReason}
                  onChange={handleChangeTimeOff}
                />
              </Form.Group>
            </Row>
            <Form.Group className="mb-2" controlId="comments">
              <Form.Label className="fs-9">Comments</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="comments"
                onChange={handleChangeTimeOff}
              />
            </Form.Group>
            <Row className="mb-2">
              <Form.Group
                as={Col}
                md={6}
                className="mb-2"
                controlId="alternativePhoneNumber"
              >
                <Form.Label className="fs-9">
                  Alternate Contact (Optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  name="alternativePhoneNumber"
                  placeholder="Enter Alternate Contact"
                  required
                  value={timeFormData?.alternativePhoneNumber}
                  onChange={handleChangeTimeOff}
                />
              </Form.Group>
              <Form.Group
                as={Col}
                md={6}
                className="mb-2"
                controlId="phoneNumber"
              >
                <Form.Label className="fs-9">Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  required
                  value={timeFormData?.phoneNumber}
                  onChange={handleChangeTimeOff}
                  disabled
                />
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
            <Button variant="primary" type="submit" className="px-4 mx-0">
              Create Time Off
            </Button>
            <Button
              variant="secondary"
              type="submit"
              className="px-4 mx-2"
              onClick={() => handleCloseTimeOff()}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Modal>
  );
};

AddScheduleModal.propTypes = {
  setIsOpenScheduleModal: PropTypes.func.isRequired,
  isOpenScheduleModal: PropTypes.bool.isRequired,
  setInitialEvents: PropTypes.func,
  initialEvents: PropTypes.array,
  scheduleStartDate: PropTypes.instanceOf(Date),
  setScheduleStartDate: PropTypes.func.isRequired,
  scheduleEndDate: PropTypes.instanceOf(Date),
  setScheduleEndDate: PropTypes.func.isRequired,
  managers: PropTypes.any,
  customers: PropTypes.any,
  nurseList: PropTypes.any,
  authToken: PropTypes.any,
  location: PropTypes.any,
  organization: PropTypes.any
};

export default AddScheduleModal;
